// gatsby-browser.js

function loadScript(src) {
  return new Promise((resolve) => {
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) existing.remove();

    const s = document.createElement("script");
    s.src = src;
    s.onload = resolve;
    document.body.appendChild(s);
  });
}

export const onRouteUpdate = async () => {
  const jq = window.jQuery;

  // Ładujemy tylko te skrypty, które faktycznie istnieją
  await loadScript("/js/jquery.colorbox.js?ver=1.0.0");
  await loadScript("/js/docready.js?ver=1.0.0");

  // Czekamy aż Colorbox będzie gotowy
  window.waitForColorbox = function (callback) {
    if (jq && jq.fn && jq.fn.colorbox) {
      callback(jq);
    } else {
      setTimeout(() => window.waitForColorbox(callback), 50);
    }
  };

  // Twoja wersja popitup
  window.popitup = function (href, element) {
    window.waitForColorbox((stableJQ) => {
      stableJQ(element).colorbox({
        iframe: true,
        href: href,
        width: window.sykonCboxWidth || 1200,
        fastIframe: false,
        overlayClose: false,
        className: "sykon-cbox",
        onComplete: function () {
          if (window.sc2_SykonAnalytics) {
            window.sc2_SykonAnalytics();
          }
        }
      });
    });
  };
};
